import { akf } from "@App/locales/akf";
import { akfLangzeitmiete } from "@App/locales/akfLangzeitmiete";
import { arval } from "@App/locales/arval";
import { ass } from "@App/locales/ass";
import { athlon } from "@App/locales/athlon";
import { autohelden } from "@App/locales/autohelden";
import { ayvens } from "@App/locales/ayvens";
import { bayerische } from "@App/locales/bayerische";
import { controlExpert } from "@App/locales/controlexpert";
import { cpm } from "@App/locales/cpm";
import { dbconnect } from "@App/locales/dbconnect";
import { de_DE_formal } from "@App/locales/de_DE-formal";
import { de_DE_informal } from "@App/locales/de_DE-informal";
import { deutscheleasing } from "@App/locales/deutscheleasing";
import { dhl } from "@App/locales/dhl";
import { dkvMobility } from "@App/locales/dkvMobility";
import { ego } from "@App/locales/ego";
import { finn } from "@App/locales/finn";
import { fleethub } from "@App/locales/fleethub";
import { generalmotors } from "@App/locales/generalmotors";
import { holman } from "@App/locales/holman";
import { itzehoer } from "@App/locales/itzehoer";
import { leasePlan } from "@App/locales/leasePlan";
import { mahle } from "@App/locales/mahle";
import { mara } from "@App/locales/mara";
import { meinauto } from "@App/locales/meinauto";
import { mfs } from "@App/locales/mfs";
import { mfsOpal } from "@App/locales/mfs-opal";
import { mobexo } from "@App/locales/mobexo";
import { mobileGarantie } from "@App/locales/mobileGarantie";
import { mobilityConcept } from "@App/locales/mobility-concept";
import { nio } from "@App/locales/nio";
import { octopusev } from "@App/locales/octopusev";
import { raiffeisenImpulsDe } from "@App/locales/raiffeisenImpulsDe";
import { repareo } from "@App/locales/repareo";
import { santander } from "@App/locales/santander";
import { signaliduna } from "@App/locales/signaliduna";
import { sixt } from "@App/locales/sixt";
import { vehiclever } from "@App/locales/vehiClever";

export const resources = {
  arval,
  akf,
  akfLangzeitmiete,
  repareo,
  dbconnect,
  finn,
  ego,
  deutscheleasing,
  fleethub,
  de_DE_formal,
  de_DE_informal,
  mobilityConcept,
  nio,
  meinauto,
  controlExpert,
  leasePlan,
  generalmotors,
  vehiclever,
  ass,
  ayvens,
  athlon,
  mobexo,
  signaliduna,
  santander,
  itzehoer,
  cpm,
  raiffeisenImpulsDe,
  mahle,
  sixt,
  mfs,
  bayerische,
  mobileGarantie,
  mfsOpal,
  mara: mara,
  holman,
  octopusev,
  autohelden,
  dhl,
  dkvMobility,
};
